import { Injectable } from '@angular/core';
import { LocationService } from '../../services/location/location.service';
import { Observable } from 'rxjs';
import { CommonHelperService } from '../../utilities/common-helper/common-helper.service';
import { Mapper } from '@dynamic-mapper/angular';
import { LocationDTO } from 'src/app/domain/location/location.dto';
import { Location } from '../../models/common/location.model';
import { LocationProfile } from '../../mappings/location/location.mapping';
import { StyistService } from '../../services/stylist/styist.service';

@Injectable({
  providedIn: 'root'
})
export class StylistBusinessService {

  constructor(
    private stylistService: StyistService,
    private commonHelper: CommonHelperService,
    private readonly mapper: Mapper
  ) { }

  onboardStylist(data): Observable<any> {
    return new Observable((observer) => {
      this.stylistService.onboardStylist(data).subscribe({
        next: (response) => {
          observer.next(response);
        },
        error: ((error) => {
          observer.error(error);
        })
      });
    })
  }

  stylistEmail(data): Observable<any> {
    return new Observable((observer) => {
      this.stylistService.stylistEmail(data).subscribe({
        next: (response) => {
          observer.next(response);
        },
        error: ((error) => {
          observer.error(error);
        })
      });
    })
  }

}
